app.AppearanceList = app.AbstractCollection.extend({
  model: app.Appearance,

  url() {
    return '/api/v2/appearances';
  },
});
